module.exports = __webpack_public_path__ + "static/media/2.f19eb136.mp3";